<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div class="container">
      <div class="row justify-content-center ">
        <div class="col-lg-4">
          <img src="/assets/images/forgot-pass.png" class="w-100  mt-0 mt-md-4 pt-0 pt-md-5" />
        </div>
        <div class="col-md-1"></div>
        <div class="col-lg-7">
          <p class="text-color font-size-25 font-weight-500 mt-4">Welcome To Reliable Doctors,</p>
          <br>
          <p class="text-change font-size-17 font-weight-500">List of Profiles Under this Account</p>

          <div class="row pt-2">
            <div class="col-md-12 d-flex">
              <div class="col-md-4 pl-0">
                <label class="font-weight-500" class="text-capitalize text-line font-weight-500">Member Name</label>
              </div>
              <div class="col-md-4 pl-0">
                <label class="font-weight-500" class="text-capitalize text-line font-weight-500">Relationship</label>
              </div>
            </div>
          </div>
          <div class="row pt-2" *ngFor="let p of profiles?.members">
            <div class="col-md-12 d-flex">
              <div class="col-md-4 pl-0">
                <label class="font-weight-500" class="text-capitalize">{{p?.first_name}}
                  {{p?.last_name}}</label>
              </div>

              <div class="col-md-4 pl-0">
                <label class="font-weight-500">{{p?.relation}}</label>
              </div>
            </div>
          </div>
          <div class="pt-3">
            <a routerLink="/patient/add" class="text-primary text-line font-weight-400">Add
              Member</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>


<!-- //Modal -->
<ng-template #confirmRequestModal let-modal>
  <div class="modal-body p-4">
    <div class="form-group row">
      <div class="col-md-12">
        <p class="font-size-18 text-center font-weight-500">CONFIRM MEMBER</p>
      </div>
    </div>
    <br><br>
    <div class="row">
      <div class="col-md-6">
        <label class="font-size-18 font-weight-500 ">ADD RELATIONSHIP</label>
      </div>
      <div class="col-md-6">
        <input type="text" class="pt-1 pb-1" />
      </div>
    </div>
    <br><br><br>
    <div class="text-center">
      <button type="button" class="btn btn-primary  btn-sm pl-3 pr-3 pl-md-4 pr-md-4 rounded-0 w-100px">Confirm</button>
    </div>
  </div>
</ng-template>